<template>
  <div class="container" :style="{'-webkit-overflow-scrolling': scrollMode}">
    <arrorImg bg="white"></arrorImg>
    <navBar title="限时免费" color="#ffffff"></navBar>
    <div class="title-top">
      <span class="mian-title">限时结束时间：{{ endTime }}</span>
      <div class="title-tabar">
        <div class="title-content">
          <div
            @click="chooseFrency(index)"
            v-for="(item, index) in items"
            :key="index"
          >
            <span :class="currentIndex == index ? 'active' : ''">{{
              item
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div :style="{'padding-top':items.length>0?'135px':'80px'}" class="content-box" v-if="!isEmpaty">
   <ul
  v-infinite-scroll="loadMore"
  :infinite-scroll-disabled="loading"
  infinite-scroll-distance="10">
   <li
        v-for="(itemChild, index) in FreeList"
        :key="index"
        @click="goDetail(itemChild)"
      >
        <uniListItem :itemChild="itemChild"></uniListItem>
      </li>
  </ul>
      <div class="load-more">
         <span>{{ !isLoading ?'加载中':loadingText }}</span>
      </div>
    </div>
    <div class="no-log" v-else>
      <img src="../../../static/no-log.png" alt="" />
      <span>没有内容哦，去其他地方看看吧~</span>
    </div>
  </div>
</template>

<script>
import {Toast, MessageBox } from "mint-ui";
import uniListItem from "../components/list-item.vue";
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
export default {
    name:'bookFree',
  components: {
    uniListItem,
    arrorImg,
    navBar,
  },
  data() {
    return {
      loading:false,
      isEmpaty: false,
      endTime: "",
      currentIndex: 0,
      items: [],
      pageNo: 1,
      pageSize: 10,
      FreeList: [],
      pageCount: 1,
      loadingText: "加载中...",
      isLoading:false,
      isRoute: false,
      isEntranceData: "",
      messageType: "",
      clickMessId: 0,
      channelRecordId: 0,
      promotionCode: "",
      pageType:'',
       scrollMode:"auto" //移动端弹性滚动效果，touch为弹性滚动，auto是非弹性滚动
    };
  },
  mounted() {
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }
    if (this.$route.query.pageType) {
      this.pageType = this.$route.query.pageType;
    }
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
    	 var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录
    } else if (isWxAuthorized==0&&city==1 && openid && !this.$store.state.user.isSNS) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.getOutReaderSwitckIsOpen();
    } else {
      this.getOutReaderSwitckIsOpen();
    }
    this.$commonApi.share();
  },
      beforeRouteLeave(to, from, next) {
     if(from.name=='bookFree'&&to.name == "bookDetail"){
      from.meta.isBack = true;
      from.meta.keepAlive = true;
     }else{
        from.meta.isBack = false;
      from.meta.keepAlive = false;
     }
    next();
  },
  methods: {
    getOutReaderSwitckIsOpen() {
      this.$api.getOutReaderSwitckIsOpen().then((res) => {
        if (res.status == 1) {
          this.frequencyDefualtType=res.data.frequencyDefualtType
        this.getfrequencyDefualtType();
        this.getLimitedAndFreeBooks();
        }
      });
      },
      getfrequencyDefualtType(){
        if (this.$base.getStorage("frequency") === "") {
          this.currentIndex=0
        }
          if(this.frequencyDefualtType==1){//男女
            this.items=["男频", "女频"]
            this.currentIndex=this.$base.getStorage("frequency")==1? parseInt(this.$base.getStorage("frequency")): 0
          
          }else if(this.frequencyDefualtType==2){//女男
            this.items=["女频", "男频"]
            this.currentIndex=this.$base.getStorage("frequency")==1? 0:1
          }
         
        },
    loadMore() {
		this.loading = true;
         if (this.pageCount > this.pageNo) {
          this.pageNo += 1;
          this.getLimitedAndFreeBooks();
        } else {
          	this.loading = false;
          this.loadingText = "没有更多了";
        }
		},
 
    insertPageAccessData() {
      var pageType = "";
      if (this.pageType == "bookMine") {
        pageType = "我的";
      } else if (this.pageType == "bookCharge") {
        pageType = "充值中心";
      } else  if (this.pageType == "bookCity") {
        pageType = "书城";
      }
      var params = {
        pageName: "限时免费",
        pageRemark:'上级页面：'+pageType+';'+(this.currentIndex == 0 ? "男" : "女"),
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    changeStatus() {
      this.isRoute = !this.isRoute;
    },
    chooseFrency(index) {
      this.currentIndex = index;
      this.pageNo = 1;
      window.scrollTo(0,0)
      this.insertPageAccessData();
      this.getLimitedAndFreeBooks();
    },
    getLimitedAndFreeBooks() {
      var frequency=0;
      if(this.frequencyDefualtType==1){
        frequency = this.currentIndex 
      }else if(this.frequencyDefualtType==2){
        frequency =  this.currentIndex ==0?1:0;
      }else if(this.frequencyDefualtType==3){
        frequency = 0;
      }else if(this.frequencyDefualtType==4){
        frequency = 1;
      }
      var params = {
        frequency:frequency,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      this.isLoading=false;
      this.$api.getLimitedAndFreeBooks(params).then((res) => {
        if (res.status == 1) {
          this.pageCount = res.pages;
          this.endTime = res.endTime;
          res.data.forEach((item) => {
            var num = (item.studyingVolume / 10000).toFixed(2);
            if (num >= 999.99) {
              item.studyingVolume = 999.99;
            } else {
              item.studyingVolume = num;
            }
          });
          if (this.pageCount > 1) {
            this.loadingText = "加载中";
               this.allLoaded=false;
          } else {
            this.allLoaded=true;
            this.loadingText = "没有更多了";
          }
          if (this.pageNo == 1) {
            this.FreeList = res.data;
          } else {
            this.FreeList = this.FreeList.concat(res.data);
          }
          if (this.FreeList.length == 0) {
            this.isEmpaty = true;
          } else {
            this.isEmpaty = false;
          }
          this.isLoading=true;
          this.insertPageAccessData();
        }
      });
    },
    goDetail(item) {
      // isEntranceData:currentName+'&限时免费'
      var isEntranceData = '(3:-1:-1:'+item.id+':'+this.currentIndex+':-1)' ;
      this.$router.push({
        path: "/pages/bookDetail/index",
        query: {
          bookId: item.id,
          pageType: "bookFree",
          isEntranceData: isEntranceData,
        },
      });
    },
  },
};
</script>

<style scoped>
.container {
  /* height:calc(48px + env(safe-area-inset-bottom)); */
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
  /* box-sizing: content-box; */
  height: 100%;
}
.title-top {
  position: fixed;
  width: 100%;
  z-index: 99;
  top: calc(44px + env(safe-area-inset-top));
   left:0;
}

.title-top {
  top: calc(44px + env(safe-area-inset-top));
}

.mian-title {
  display: block;
  width: 100%;
  height: 36px;
  background-color: rgb(251, 235, 234);
  font-size: 12px;
  color: #de3b34;
  text-align: center;
  line-height: 36px;
  margin:0 auto;
}

.title-tabar {
  border-bottom: 1px solid #f3f3f3;
  background-color: #ffffff;
}

.title-content {
  width: 100%;
  display: flex;
}

.title-content > div {
  flex: 1;
  text-align: center;
  padding-top: 12px;
  padding-bottom: 10px;
}

.title-content span {
  font-size: 16px;
  color: #aaaaaa;
  padding-bottom: 4px;
  border-bottom: 3px solid #ffffff;
}

.title-content span.active {
  color: #de3b34;
  border-bottom: 3px solid #de3b34;
}
.content-box {
  /* height: 100%;
  overflow:scroll; */

  padding: 0px 16px;
    /* padding-top: calc(135px + env(safe-area-inset-top)); */
      padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
}
.load-more {
  text-align: center;
   font-size: 12px;
color: #AAAAAA;
  padding: 16px 0px;
}

.no-log {
  width: 100%;
  padding-top: 100px;
}

.no-log span {
  font-size: 14px;
  color: #666666;
  margin-top: 20px;
  display: block;
  text-align: center;
}
.no-log img {
  width: 128px;
  height: 128px;
  display: block;
  margin: 0 auto;
  margin-top: 144px;
}

</style>



// WEBPACK FOOTER //
// src/view/bookFree/index.vue